import type { StyleProp } from '@vtex/admin-ui'
import { csx } from '@vtex/admin-ui'
import React from 'react'
import { graphql } from 'babel-plugin-relay/macro'
import { useFragment } from 'react-relay-offline'

import { Avatar } from '../Avatar'
import { SalesAssociateMovementsTrackingModalItem } from '../SalesAssociateMovementsTrackingModal'
import type { SalesAssociatesContentTemplateItem_salesAssociate$key } from './__generated__/SalesAssociatesContentTemplateItem_salesAssociate.graphql'

const getSellerNameStyles = ({
  selected,
}: {
  selected: boolean
}): StyleProp => ({
  fontWeight: selected ? 600 : 500, // NEED_PERFORMANCE_REVIEW
})

type SalesAssociateData = {
  id: string
  name: string | null
}

export type SalesAssociatesContentTemplateItemProps = {
  onClick: (salesAssociateData: SalesAssociateData) => void
  selected: boolean
  salesAssociateRef: SalesAssociatesContentTemplateItem_salesAssociate$key
}

export const SalesAssociatesContentTemplateItem = ({
  onClick,
  selected,
  salesAssociateRef,
}: SalesAssociatesContentTemplateItemProps) => {
  const salesAssociateData = useFragment<SalesAssociatesContentTemplateItem_salesAssociate$key>(
    graphql`
      fragment SalesAssociatesContentTemplateItem_salesAssociate on SalesAssociate {
        id
        name
        avatar {
          url
        }
      }
    `,
    salesAssociateRef
  )

  const handleClick = () => {
    onClick({
      id: salesAssociateData.id,
      name: salesAssociateData.name,
    })
  }

  return (
    <SalesAssociateMovementsTrackingModalItem
      onClick={handleClick}
      selected={selected}
      hasChildren={false}
      data-testid="occurrences-modal-item"
    >
      <div className={csx({ display: 'flex', alignItems: 'center' })}>
        <Avatar
          src={salesAssociateData.avatar?.url}
          size={2.25}
          className={csx({ marginRight: '$space-2' })}
        />
        <span
          className={csx(
            getSellerNameStyles({
              selected,
            })
          )}
        >
          {salesAssociateData.name}
        </span>
      </div>
    </SalesAssociateMovementsTrackingModalItem>
  )
}
